module.exports = __webpack_public_path__ + "static/media/emo.54dd47c8.svg";